// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e087143","453":"0ca90815","455":"791a005b","977":"cb37ec6e"}[chunkId] + ".chunk.js";
};